import { createPinia } from 'pinia';

/** Single Pinia instance for the hub host — never use a sub-app's active Pinia for hub stores. */
export const hubPinia = createPinia();
